import { render, staticRenderFns } from "./Mailing.vue?vue&type=template&id=75b6dd8a&scoped=true&"
import script from "./Mailing.vue?vue&type=script&lang=js&"
export * from "./Mailing.vue?vue&type=script&lang=js&"
import style0 from "./Mailing.vue?vue&type=style&index=0&id=75b6dd8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b6dd8a",
  null
  
)

export default component.exports